import { graphql as tadaGraphql } from '@savvy/deprecated-shared/gql-compat';

export const XLoginFormFragment = tadaGraphql(/* GraphQL */ `
  fragment LoginForm on Client {
    user {
      email
    }
  }
`);
